module.exports = __webpack_public_path__ + "img/money.ee1d8b59.png";